<template>
  <div
    class="sidebar h-100"
    :class="{ hide: isHideNav }"
    style="min-height: calc(100vh - 96px)"
  >
    <div
      class="sidebar-group"
      v-for="(item, index) in navList[clientId]"
      :key="clientId + index"
    >
      <div class="sidebar-title">{{ item.title }}</div>
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item p-0"
          v-for="(nav, index) in item.navList"
          :key="clientId + 'Nav' + index"
        >
          <router-link class="nav-link" :to="{ name: nav.routerName }">
            <i class="pe-2" :class="nav.icon"></i>
            <span>{{ nav.name }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Sidebar',
  data () {
    return {}
  },
  computed: {
    ...mapState(['isHideNav', 'viewport', 'navList']),
    ...mapGetters(['clientId'])
  },
  watch: {
    viewport (data) {
      if (data === 'md' || data === 'sm') {
        this.HidingNav()
      }
    }
  },
  methods: {
    ...mapMutations(['HidingNav'])
  },
  created () {},
  mounted () {
    if (this.viewport === 'md' || this.viewport === 'sm') {
      this.HidingNav()
    }
  }
}
</script>

<style lang="scss">
.sidebar {
  position: relative;
  background-color: #fff;
  padding: 20px 0;
  width: 265px;
  border-radius: 0 10px 0 0;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease-in-out;
  z-index: 1;
  overflow: hidden;
  .list-group-flush > .list-group-item {
    border: none;
  }
  &-group {
    padding-bottom: 20px;
    width: 265px;
  }
  &-title {
    padding: 5px 26px;
    color: $gray;
    transition: all 0.3s ease-in-out;
    height: 34px;
  }
  .nav-link {
    padding: 10px 26px;
    color: $dark;
    &:hover {
      background-color: desaturate(lighten($primary, 25%), 60%);
    }
    &.active {
      background-color: desaturate(lighten($primary, 25%), 60%);
      color: $primary;
    }
  }
  span {
    transition: opacity 0.3s ease-in-out;
  }
  &.hide {
    width: 54px;
    &:hover {
      width: 265px;
      span {
        opacity: 1;
      }
    }
    .nav-link {
      padding: 10px 15px;
      @include media-breakpoint-down(md) {
        padding: 10px;
      }
    }
    .sidebar-title {
      height: 0;
      padding: 0;
      opacity: 0;
    }
    span {
      opacity: 0;
    }
  }
}
</style>
